.body {
  padding-bottom: calc(var(--spacingLg) + 64px); // 64px matches the fixed PageFooter height
}
